import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "card mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " Consulta de Usuarios ", -1)
const _hoisted_9 = { class: "card-body" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/registro_usuario" }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  class: "vue-link",
                  label: "Registrar Usuario",
                  icon: "fa fa-user-plus",
                  link: ""
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DataTable, {
              value: _ctx.users,
              stripedRows: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "user",
                  header: "Usuario"
                }),
                _createVNode(_component_Column, {
                  field: "perfil",
                  header: "Perfil"
                }, {
                  body: _withCtx((prop) => [
                    _createTextVNode(_toDisplayString(_ctx.formatPerfil(prop.data.perfil)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Acciones" }, {
                  body: _withCtx((prop) => [
                    _createVNode(_component_Button, {
                      class: "me-2",
                      icon: "fa fa-pencil",
                      severity: "success",
                      onClick: $event => (_ctx.editUser(prop.data.uuid))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      class: "me-2",
                      icon: "fa fa-trash",
                      severity: "danger",
                      onClick: $event => (_ctx.deleteUser(prop.data.uuid, prop.data.nombre))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ])
  ], 64))
}